import { endOfMonth, format, parseISO } from 'date-fns';
import { FilterGroupingEnum } from 'graphql-common';
import { getCetDayRangeBounds } from '@lib/utils/dateTimeHelpers';

const MONTH_BUCKET_REGEXP = /^\d{4}-\d{2}$/;
const DAY_BUCKET_REGEXP = /^\d{4}-\d{2}-\d{2}$/;

/**
 * `tasksTimeline` buckets completions by `created_at` truncated to the day or
 * month in the backend's zone (Europe/Paris), so a cell's completions are
 * those created between the bucket's first CET midnight and its last CET
 * end-of-day.
 */
export function getBucketDateRange(bucketId: string | null | undefined) {
  if (!bucketId) return null;
  let startYmd: string;
  let endYmd: string;
  if (MONTH_BUCKET_REGEXP.test(bucketId)) {
    startYmd = `${bucketId}-01`;
    // Only the calendar digits are read back, in the same (local) zone
    // `parseISO` produced them in.
    endYmd = format(endOfMonth(parseISO(startYmd)), 'yyyy-MM-dd');
  } else if (DAY_BUCKET_REGEXP.test(bucketId)) {
    startYmd = bucketId;
    endYmd = bucketId;
  } else {
    return null;
  }
  return getCetDayRangeBounds(startYmd, endYmd);
}

// `createdAt` filters narrowing a completions / media query to one timeline
// bucket; empty when there's no bucket (the whole recurring check).
export default function getBucketCreatedAtFilters(
  bucketId: string | null | undefined,
) {
  const range = getBucketDateRange(bucketId);
  if (!range) return [];
  return [
    {
      createdAt: {
        grouping: FilterGroupingEnum.And,
        predicate: { gteq: range.start },
      },
    },
    {
      createdAt: {
        grouping: FilterGroupingEnum.And,
        predicate: { lteq: range.end },
      },
    },
  ];
}
